import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=d9d4ecb4"
import script from "./ThePagination.vue?vue&type=script&lang=js"
export * from "./ThePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports